import axios from 'axios'

export default ({ store }, inject) => {
  const RENTCARS_PUBLIC_API_CLIENT = axios.create({
    baseURL: process.env.RENT_PUBLIC_API,
    timeout: 60000,
    headers: {
      'mobicar-requestor-id': store.getters.getMobicarRequestorID
    }
  })

  RENTCARS_PUBLIC_API_CLIENT.interceptors.request.use((config) => {
    config.headers['mobicar-requestor-id'] = store.getters.getMobicarRequestorID
    return config
  })

  inject('rentcarsPublicApi', RENTCARS_PUBLIC_API_CLIENT)
}
